import React from 'react';
import { View, StyleSheet, ImageBackground } from 'react-native';
import { DataTable } from 'react-native-paper';
import { COLORS, IMAGES } from '../constants';
import { CategoriesList } from '../components'

export default function GroupsScreen() {
  return (

    <View style={styles.container}>
        <CategoriesList/>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
      flex: 1,
      backgroundColor: COLORS.background,
  },
  tbl: {
      color: COLORS.primary,
  },
  bg: {
    width: '100%',
    height: '100%'
  },
});